import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const AnswerOptionForm = ({
  enableGlobalLoader,
  disableGlobalLoader,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [answerOption, setAnswerOption] = useState({"name": ""});
  const editMode = rest.kmaction === 'edit';

  let pageTitle =
    rest.kmaction === "new"
      ? "Nowa wariant odpowiedzi"
      : "Edycja wariantu odpowiedzi";

  useEffect(() => {
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(
        apiEndpoints.getAnswerOptionDetails.path,
        entryId,
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setAnswerOption(data);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    }
    return () => {};
  }, []);

  const onSubmit = (values) => {
    enableGlobalLoader();

    if (editMode) {
      apiPutRequest(
        apiEndpoints.updateAnswerOption.path,
        {
          id: entryId,
          name: values.name,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/administracja/slowniki/4");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    } else {
      apiPostRequest(
        apiEndpoints.addAnswerOption.path,
        {
          name: values.name,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/administracja/slowniki/4");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} answerOption={answerOption} editMode={editMode}/>
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(AnswerOptionForm);
